import { Container } from '@youhelp-ru/ui';
import { styled } from '@cp/ds/src/theme';
import { ComponentType, PropsWithChildren } from 'react';
import { name } from './const';

export const DialogContainer = styled(Container, { name, slot: 'Container' })({
  width: '100%',
  boxSizing: 'border-box',
  '&:empty': { display: 'none' },
}) as unknown as ComponentType<PropsWithChildren>;
